var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MarketTemplate } from "../../data";
import { emptySelection, emptySelectionPointBox } from "../../constants";
export var fillEmptyMarketSelections = function (template) {
    var selections = [];
    template === MarketTemplate.PointBox && selections.push(__assign({}, emptySelectionPointBox));
    var counter = template === MarketTemplate.ThreeBox ? 3 : 2;
    for (var i = 0; i < counter; i++) {
        selections.push(emptySelection);
    }
    return selections;
};
//# sourceMappingURL=fillEmptyMarketSelections.js.map